<template>
  <div class="main-menu">
    <Header v-if="!$isV2" ref="header" />
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
import Header from '@/components/Header/index.vue'
export default {
  name: 'MainMenu',
  components: {
    Header
  }
}
</script>

<style lang="scss" scoped>

.main-menu {
  height: 100%;
}
</style>
